var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCourseEndTest(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.35,
    height: 35.24,
    viewBox: "0 0 35.35 35.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6152",
    "data-name": "Path 6152",
    d: "M26.77,22a8.59,8.59,0,1,1,8.58-8.59A8.59,8.59,0,0,1,26.77,22Zm0-14.23a5.625,5.625,0,1,1,0,.03Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1556",
    "data-name": "Line 1556",
    x2: 13.42,
    transform: "translate(5.85 23.47)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6153",
    "data-name": "Path 6153",
    d: "M19.27,24.86H5.85a1.4,1.4,0,1,1,0-2.79H19.27a1.4,1.4,0,1,1,0,2.79Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1557",
    "data-name": "Line 1557",
    x2: 13.42,
    transform: "translate(5.85 27.88)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6154",
    "data-name": "Path 6154",
    d: "M19.27,29.28H5.85a1.4,1.4,0,1,1,0-2.8H19.27a1.4,1.4,0,0,1,0,2.8Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1558",
    "data-name": "Line 1558",
    x2: 9.12,
    transform: "translate(7.98 5.78)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6155",
    "data-name": "Path 6155",
    d: "M17.1,7.18H8A1.4,1.4,0,0,1,8,4.39h9.1a1.4,1.4,0,1,1,0,2.79Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6156",
    "data-name": "Path 6156",
    d: "M5.85,10.23H17.48a10.17,10.17,0,0,1,.6-1.4H5.85a1.4,1.4,0,1,0,0,2.8H17.1a9.32,9.32,0,0,1,.38-1.4Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6157",
    "data-name": "Path 6157",
    d: "M5.85,14.64H17a9.42,9.42,0,0,1-.08-1.2c0-.06,0-.13,0-.19H5.85a1.4,1.4,0,1,0,0,2.79H17.29a9.13,9.13,0,0,1-.28-1.4Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6158",
    "data-name": "Path 6158",
    d: "M5.85,19.06H18.7a9.78,9.78,0,0,1-.81-1.4h-12a1.4,1.4,0,1,0,0,2.79H19.27a1.25,1.25,0,0,0,.51-.1,11.18,11.18,0,0,1-1.08-1.29Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1984",
    "data-name": "Rectangle 1984",
    width: 4.34,
    height: 2.17,
    transform: "translate(24.6 2.18)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6159",
    "data-name": "Path 6159",
    d: "M24.79,1.67A2.72,2.72,0,0,0,22.28,0H2.74A2.74,2.74,0,0,0,0,2.74V32.51a2.74,2.74,0,0,0,2.74,2.73H22.28A2.73,2.73,0,0,0,25,32.51V23.07a9.72,9.72,0,0,1-2.94-1V32.3H2.94V2.94H22.07V4.85a10,10,0,0,1,1.5-.66V1.67Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1985",
    "data-name": "Rectangle 1985",
    width: 1.6,
    height: 4.96,
    transform: "translate(25.97 8.83)",
    fill: "#525252"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCourseEndTest);
export default __webpack_public_path__ + "static/media/icon_course_end_test.ecf1182710ba2c0e02b87239efc451df.svg";
export { ForwardRef as ReactComponent };